import colors from '~/styles/_colors.css'

export default function getColor(color) {
    return colors[color] || color || ''
}
